import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ConfigService } from '../configHelper';

@Injectable({
   providedIn: 'root'
})
export class LabDataService {

   constructor(private httpClient: HttpClient, private configService: ConfigService) {
   }

   public getEmptyModel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetEmptyModel`;
      return this.httpClient.get(url);
   }

   public getLabList() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetLabList`;
      return this.httpClient.get(url);
   }

   public getLabById(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetLab?id=${id}`;
      return this.httpClient.get(url);
   }

   public GetLabPanels() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetLabPanels`;
      return this.httpClient.get(url);
   }

   public saveLab(lab) {
      if (lab.Id === 0) {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/Lab`;
         return this.httpClient.post(url, lab);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/Lab?id=${lab.Id}`;
         return this.httpClient.put(url, lab);
      }
   }

   public getEmptyPanel() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetEmptyPanel`;
      return this.httpClient.get(url);
   }

   public getPanelsForLab(labId) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetPanelsForLab?labId=${labId}`;
      return this.httpClient.get(url);
   }

   public getPanelById(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetPanel?id=${id}`;
      return this.httpClient.get(url);
   }

   public savePanel(panel) {
      if (panel.Id === 0) {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/Panel`;
         return this.httpClient.post(url, panel);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/Panel?id=${panel.Id}`;
         return this.httpClient.put(url, panel);
      }
   }

   public getEmptyTest() {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetEmptyTest`;
      return this.httpClient.get(url);
   }

  public getAllTests() {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetAllTests`;
    return this.httpClient.get(url);
  }

   public getTestsForPanel(panelid) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetTestsForPanel?panelid=${panelid}`;
      return this.httpClient.get(url);
   }

   public getTestsForSpecimenType(specimenTypeCode) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetTestsBySpecimenType?specimenType=${specimenTypeCode}`;
      return this.httpClient.get(url);
   }

   public searchTests(search) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/SearchTests?search=${search}`;
      return this.httpClient.get(url);
   }

   public addTestPanelLink(labPanelId, labTestId) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/AddTestPanelLink?labPanelId=${labPanelId}&labTestId=${labTestId}`;
      return this.httpClient.get(url);
   }

   public getTestById(id) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetTest?id=${id}`;
      return this.httpClient.get(url);
   }

   public getTestAssayGroupMatches(search) {
      let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/GetAssayGroupMatches?search=${search}`;
      return this.httpClient.get(url);
   }

   public saveTest(test) {
      if (test.Id === 0) {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/Test`;
         return this.httpClient.post(url, test);
      } else {
         let url: string = `${this.configService.getConfig().apiURL}v1/Internal/Lab/Test?id=${test.Id}`;
         return this.httpClient.put(url, test);
      }
   }
}
